export default "__VITE_ASSET__Q0r5sAUI__"